var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mega-menu",class:_vm.classes},[_c('div',{staticClass:"mega-menu__container"},[_c('div',{staticClass:"mega-menu__content"},[_vm._t("default",function(){return [_vm._v("Content!")]})],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }